import { render } from "./StairsIcon.vue?vue&type=template&id=51ebf860&ts=true"
import script from "./StairsIcon.vue?vue&type=script&lang=ts"
export * from "./StairsIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__